import { intl } from '../platform/localization'

export const messages = {
  // these messages is used outside of react components, please make sure it has id
  invalidSession: intl.formatMessage({
    id: 'invalidSession',
    defaultMessage: 'Please sign into Salesloft in the sidebar.',
    description: 'Error message when the user is not signed into Salesloft',
  }),
  get textNotifySomethingWentWrong() {
    return intl.formatMessage({
      defaultMessage: 'Something went wrong',
      description: 'Text notify if something went wrong',
    })
  },
  get textNotifyRecipientsDNC() {
    return intl.formatMessage({
      defaultMessage: 'Recipients are either marked DNC or have email contact restrictions',
      description:
        'Text notify recipients are either marked DNC or have email contact restrictions',
    })
  },
  get textNotifyNoAccessToRecipients() {
    return intl.formatMessage({
      defaultMessage: 'You do not have read access to these recipients',
      description: 'Text notify you do not have read access to these recipients',
    })
  },
  get textNotifyTemplateNotInserted() {
    return intl.formatMessage({
      defaultMessage: 'Template cannot be inserted',
      description: 'Text notify template cannot be inserted',
    })
  },
  responseErrorEmailReply(errorMessage: string) {
    return intl.formatMessage(
      {
        defaultMessage: '{errorMessage}',
        description: 'Error message from response for email replies in sentiments',
      },
      {
        errorMessage,
      }
    )
  },
}
